import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './HeroSection.module.css';


const HeroSection = () => {
    const [isLearnMoreHovered, setIsLearnMoreHovered] = useState(false);
    const navigate = useNavigate();
   
    const handleJoinClick = () => {
      navigate('/join'); 
    };
    
    return (
        <section id="hero" className={styles.heroSection}>
            <div className={styles.heroContent}>
                <h1 className={styles.headline}>
                    Trade Smarter. Backtest First.  
                </h1>
                <p className={styles.subheadline}>
                   <strong>AI can help with near real-time crypto, stock and index analysis.</strong>
                </p>
                
                <div className={styles.ctaButtons}>
                    <button 
                        onClick={handleJoinClick}
                        className={styles.primaryButton}
                        onMouseEnter={() => setIsLearnMoreHovered(true)}
                        onMouseLeave={() => setIsLearnMoreHovered(false)}
                    >
                        {isLearnMoreHovered ? 'Free Community Version' : 'Learn more'}
                        <span className={styles.buttonGlow}></span>
                    </button>
                </div>
                <p className={styles.ctaSubtext}> &nbsp;Join us and be part of something bigger.</p>
            </div>
        </section>
    );
};

export default HeroSection;